import { Navigate, Outlet, useLocation } from "react-router-dom";
import ROUTES from "../routes";

const ProtectedRoute = () => {
    const isAuthenticated = !!window.sessionStorage.getItem("authToken");
    const location = useLocation();

    if (!isAuthenticated) {
        const redirect = location.pathname + location.search;
        const redirectParam = redirect === "/" ? "" : `?redirect=${encodeURIComponent(redirect)}`;
        return <Navigate to={`${ROUTES.LOGIN}${redirectParam}`} replace />;

    }

    return <Outlet />;
};

export default ProtectedRoute;
